module.exports = __webpack_public_path__ + "img/news4.1f485c94.jpg";